export default "__VITE_ASSET__ONYc3evM__"